import { toggleTemplateModal } from '../../../redux/slices/whatsappTemplate';
import { Button } from 'react-bootstrap';
import { useTranslate } from '@tolgee/react';
import { dispatch } from '../../../redux/store';
import { useSelector } from 'react-redux';

export const OpenWhatsAppTemplateModal = () => {
  const { t } = useTranslate();

  const { openTemplateModal } = useSelector(
    (state: any) => state.WhatsappTemplateBuilder
  );

  return (
    <Button
      size={'sm'}
      variant="white"
      className={'shadow'}
      onClick={() => {
        dispatch(toggleTemplateModal(true));
      }}
    >
      <span>
        <i
          className={'fab fa-whatsapp text-success'}
          style={{ fontSize: '20px' }}
        ></i>{' '}
      </span>
      <span>{t('communication.whatsapp.template')}</span>
    </Button>
  );
};
